import { List as IList } from 'immutable';

import { history } from '../routing/routing';

import { paymentMethodStepCompleted } from '../paymentMethod/paymentMethodStepSelectors';


export const paymentStepCompleted = () => (
    !!(history.location.state
        && history.location.state.orderData
        && history.location.state.paymentData)
);


export const paymentStepPreConditions = IList([
    paymentMethodStepCompleted
]);


export const paymentStepPostConditions = IList([
    paymentMethodStepCompleted,
    paymentStepCompleted
]);


export const paymentStepSkippable = () => false;
